import type { ApPurchaseDocument } from "@/accounts-payable/types";
import {
  formatApZonedDateTime,
  reviewStateMeta,
} from "@/accounts-payable/utils";
import { StatusBadge } from "./shared";
import { useApBusinessTimeZone } from "./use-ap-business-time-zone";

/**
 * Whether a person still has to look at the document's agent proposals. A
 * reviewed badge carries when it became reviewed, in the business's time
 * zone, as a tooltip.
 */
export const ReviewBadge = ({
  document,
}: {
  document: Pick<ApPurchaseDocument, "review_state" | "reviewed_at">;
}) => {
  const timeZone = useApBusinessTimeZone();
  const meta = reviewStateMeta(document.review_state);
  if (!meta) return <span className="text-tertiary-text">—</span>;

  const reviewedAt = formatApZonedDateTime(document.reviewed_at, timeZone);
  return (
    <span title={reviewedAt && `Reviewed ${reviewedAt}`}>
      <StatusBadge meta={meta} />
    </span>
  );
};
